import React from "react";

const ProgressBar: React.VFC<{ progress: number }> = ({ progress }) => {
    return (
        <div
            style={{
                width: `${progress}%`,
            }}
            className="h-0.5 bg-gray-lightx w-1/2 -mt-0.5"
        ></div>
    );
};

export default ProgressBar;
